import React, { useEffect } from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import ChatIdPage from "../Pages/ChatIdPage";
import Auth from "../Components/Auth/Auth";
import ProfilePage from "../Pages/ProfilePage";
import RecentPage from "../Pages/RecentPage";
import TermsPage from "../Pages/TermsPage";
import ErrorHandler from "../Components/ErrorHandler";
import ErrorBoundary from "../Pages/ErrorBoundary";
import FreeChatDemoPage from "../Pages/FreeChatDemoPage";
import HomePage from "../Pages/NewDesign/HomePage";
import ChatPage from "../Pages/NewDesign/ChatPage";
import LoginPage from "../Pages/LoginPage";
import SubscriptionPage from "../Pages/SubscriptionPage";
import OtpPage from "../Pages/OtpPage";
import SubscriptionProcessing from "../Pages/SubscriptionProcessing";

const Routing = () => {
  const router = createBrowserRouter([
    {
      path: "/login",
      element: <LoginPage />
    },
    {
      path: "/",
      element: <SubscriptionPage />
    },
    {
      path: "/otp",
      element: <OtpPage />
    },
    {
      path: "/subscription-processing",
      element: <SubscriptionProcessing />,
    },
    {
      path: "/app",
      element: (
        <Auth>
          <ChatPage />
        </Auth>
      ),
      errorElement: <ErrorBoundary />,
    },
    {
      path: "/app/:chat_id",
      element: (
        <Auth>
          <ChatIdPage />
        </Auth>
      ),
      errorElement: <ErrorBoundary />,
    },
    {
      path: "/profile",
      element: (
        <Auth>
          <ProfilePage />
        </Auth>
      ),
      errorElement: <ErrorBoundary />,
    },
    {
      path: "/recent",
      element: (
        <Auth>
          <RecentPage />
        </Auth>
      ),
      errorElement: <ErrorBoundary />,
    },
    {
      path: "/terms",
      element: <TermsPage />,
      errorElement: <ErrorBoundary />,
    },
    // {
    //   path: "/demo",
    //   element: <FreeChatDemoPage />,
    //   errorElement: <ErrorBoundary />,
    // },
    {
      path: "*",
      element: (
        <ErrorHandler
          icon="pi pi-ban"
          type="page-not-found"
          message="Page Not Found!"
        />
      ),
      errorElement: <ErrorBoundary />,
    },
  ]);
  return <RouterProvider router={router} />;
};

export default Routing;
